import Box from "./Box";
import React from "react";

function BoxWithGutter({ children, ...props }) {
  return (
    <Box {...props} px={[15, "4.76vw", null, null]}>
      {children}
    </Box>
  );
}

export default BoxWithGutter;
